import { useTranslation } from "react-i18next";
import { Form, Input } from "antd";

import { validateEmail } from "../../utils/validateEmail";

import type { FormInstance } from "antd";

interface Props {
  entityForm: FormInstance;
}

export const SubscriptionEntityForm = ({ entityForm }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Form
        form={entityForm}
        layout="vertical"
        className="subscription-entity-form"
      >
        <div className="subscription-entity-form__fields">
          <Form.Item
            name="company_name"
            label={t("subscription.orgName")}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="contact_person"
            label={t("subscription.contactPerson")}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="contact_email"
            label={t("profile.email")}
            rules={[
              { required: true },
              {
                validator: (_, value) =>
                  !value || validateEmail(value)
                    ? Promise.resolve()
                    : Promise.reject(t("errors.shared.invalid_email")),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="contact_phone"
            label={t("subscription.contactPhone")}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </div>
      </Form>
    </>
  );
};
